<template>
  <v-row class="pt-0" style="height: 100%;">
    <Teleport to="#settings-group-header">
      Создание магазина
    </Teleport> 
    <v-col cols="12">
      <ShopCreate
        :corporation="corporation"
        :corporations="corporations.items"
        @onSubmit="addShop"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Teleport from 'vue2-teleport';
import ShopCreate from '@/components/shops/shop-create/index.vue';

export default{
  props:{
    corporation: Object
  },

  data:() => ({
    loading: false
  }),
  
  computed:{
    ...mapGetters('data', ['corporations']),
  },

  methods:{
    ...mapActions('data', ['corporations_list', 'shop_create']),

    async addShop(shop){
      this.loading = true;
      await this.shop_create(shop);
      this.loading = false;

      this.$router.push('/')
    }
  },

  async mounted(){
    this.loading = true;
    await this.corporations_list()
    this.loading = false;
  },

  components:{
    Teleport,
    ShopCreate,
  }
}
</script>